import * as React from 'react';
import { InputProps } from 'interfaces';
import { Input } from '../input/input';
import { CypressI } from 'interfaces/cypress';

export const InputText = React.forwardRef<
	HTMLInputElement,
	InputProps & CypressI & React.InputHTMLAttributes<HTMLInputElement>
>((props, ref) => {
	return <Input type="text" {...props} ref={ref} />;
});

InputText.displayName = 'InputText';
